module.exports = __webpack_public_path__ + "img/GA.bf2d0372.png";